// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: in the native shell, push tokens (APNs, VoIP, Live Activity
// push-to-start, FCM) are fetched and registered by native code against
// /users/@me/mobile-devices. The web side only asks for it once the OS
// permission is granted and the session has been handed over.

import {NativePlugins} from '@app/features/platform/native_mobile/NativeMobileBridge';
import {refreshNativeNotificationPermission} from '@app/features/platform/native_mobile/NativeMobileNotificationShim';
import {syncNativeSessionNow} from '@app/features/platform/native_mobile/NativeMobileSession';
import {Logger} from '@app/features/platform/utils/AppLogger';

const logger = new Logger('NativeMobilePush');

let registerPromise: Promise<string | null> | null = null;

export function registerNativeMobilePush(): Promise<string | null> {
	if (registerPromise) return registerPromise;
	registerPromise = (async () => {
		const push = NativePlugins.push();
		if (!push) return null;
		try {
			if ((await refreshNativeNotificationPermission()) !== 'granted') return null;
			await syncNativeSessionNow();
			const result = await push.register();
			logger.info('Native push registered', result);
			return result.registered ? result.platforms.join(',') : null;
		} catch (error) {
			logger.warn('Native push registration failed', error);
			return null;
		} finally {
			registerPromise = null;
		}
	})();
	return registerPromise;
}

export async function unregisterNativeMobilePush(): Promise<void> {
	const push = NativePlugins.push();
	if (!push) return;
	try {
		await push.unregister();
	} catch (error) {
		logger.warn('Native push unregister failed', error);
	}
}
